import Navbar from './Navbar'
import './styles.css'
import { useState } from 'react'
import { COLUMNS_BASIC, COLUMNS_EDITABLE, MOCK_DATA, NEW_STUDENT } from '../experiment/data/fake-data/FakeReactTableData'
import TableEditable from '../experiment/table/table-editable/TableEditable'
import TableBasic from '../experiment/table/table-basic/TableBasic'

export default function Component() {
  const [frm, setFrm] = useState({
    date: '',
    time: ''
  })
  const [data] = useState([...MOCK_DATA]);
  // event
  const handleSubmit = () => {
  }
  const onChange = (event: { target: { type: string, value: any } }) => {
    let inputs = {}
    if (event.target.type === 'date') {
      inputs = { date: event.target.value }
    } else if (event.target.type === 'time') {
      inputs = { time: event.target.value }
    }
    setFrm({ ...frm, ...inputs })
  }

  const onSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault()
    if (!frm.date || !frm.time) {
      return
    } else {
      console.log(new Date(`${frm.date} ${frm.time}`))
    }
  }

  return (
    <div>
      <Navbar />
      <main className='container-md main-content'>
        {/* input text */}
        <div>
          <h3>input text</h3>
          <div className='row align-items-center'>
            <label className='text-nowrap col-auto'>label text</label>
            <div className='p-1'><input type='text' id='text-id-name' name='text-name' /></div>
          </div>
        </div>
        <hr />
        {/* input number */}
        <div>
          <h3>input number</h3>
          <div className='row align-items-center'>
            <label className='text-nowrap col-auto'>label number</label>
            <div className='p-1'><input type='number' id='number-id-name' name='number-name' /></div>
            <span id={`number-id-error`} className='form-text m-1'>* required</span>
          </div>
        </div>
        <hr />
        {/* input file */}
        <div>
          <h3>input file</h3>
          <div className='row align-items-start'>
            <label>Input file:
              <input className='ms-1' type='file' name='file-name' id='file-id-name' />
            </label>
          </div>
        </div>
        <hr />
        {/* textarea */}
        <div>
          <h3>textarea</h3>
          <div className='d-flex flex-row align-items-start g-3'>
            <label className='text-nowrap col-auto'>label textarea</label>
            <div className='p-1'><textarea id='textarea-id-name' name='textarea-name' rows={2} cols={30} /></div>
            <span id={`textarea-id-error`} className='form-text m-1'>* required</span>
          </div>
        </div>
        <hr />
        {/* select option */}
        <div>
          <h3>select option</h3>
          <div className='row align-items-center'>
            <label className='text-nowrap col-2'>pick a fruit:</label>
            <div className='p-1 col-auto'>
              <select name='selectedOption' defaultValue='option3'>
                <option value='option1'>option1</option>
                <option value='option2'>option2</option>
                <option value='option3'>option3</option>
              </select>
            </div>
          </div>
        </div>
        <hr />
        {/* checkbox */}
        <div>
          <h3>checkbox</h3>
          <div className='row align-items-center'>
            <div className='col-auto'><label>Checkbox</label></div>
            <div className='col-auto p-0'>
              <div className='d-flex align-items-center'><input className='ms-1' type='checkbox' name='myCheckbox' /></div>
            </div>
          </div>
        </div>
        <hr />

        {/* datetime picker */}
        <div>
          <h3>datetime picker</h3>
          <div className='row align-items-center'>
            <label className='text-nowrap col-auto'>date</label>
            <div className='p-1'><input type='date' id='date-id-name' name='date-name' value={frm.date} onChange={onChange} /></div>
            <span id={`date-id-error`} className='form-text m-1'>* required</span>
          </div>
          <div className='row align-items-center'>
            <label className='text-nowrap col-auto'>time</label>
            <div className='p-1'><input type='time' id='time-id-name' name='time-name' value={frm.time} onChange={onChange} /></div>
            <span id={`time-id-error`} className='form-text m-1'>* required</span>
          </div>
        </div>
        <hr />


        {/* radio buttons */}
        <div>
          <h3>radio buttons</h3>
          <div className='row align-items-start'>
            radio buttons:
            <label>
              <input className='me-1' type='radio' name='myRadio' value='option1' />
              option 1
            </label>
            <label>
              <input className='me-1' type='radio' name='myRadio' value='option2' />
              option 2
            </label>
            <label>
              <input className='me-1' type='radio' name='myRadio' value='option3' />
              option 3
            </label>
          </div>
        </div>
        <hr />

        {/* Content */}
        <div className='row align-items-start'>
          <label className='text-nowrap col-2'>label</label>
          <div className='p-1 col'><p className='fw-semibold m-0'>content</p></div>
        </div>
        <hr />

        {/* button */}
        <div>
          <h3>button</h3>
          <div className='row align-items-start'>
            <button type='button' onClick={onSubmit}>submit</button>
          </div>
        </div>
        <hr />

        {/* table */}
        <div>
          <h3>table (small, small responsive, border, caption, head-body) </h3>
          <div className='row align-items-start'>
            <table className='table table-sm table-responsive-sm table-bordered'>
              <caption className='caption-top'>List of users</caption>
              <thead>
                <tr>
                  <th scope='col'>#</th>
                  <th scope='col'>First</th>
                  <th scope='col'>Last</th>
                  <th scope='col'>Handle</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope='row'>1</th>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                </tr>
                <tr>
                  <th scope='row'>2</th>
                  <td>Jacob</td>
                  <td>Thornton</td>
                  <td>@fat</td>
                </tr>
                <tr>
                  <th scope='row'>3</th>
                  <td colSpan={2}>Larry the Bird</td>
                  <td>@twitter</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr />
        {/* table basic */}
        <TableBasic id='students-id' columns={COLUMNS_BASIC} fetchData={data} />
        <hr />
        {/* table editable */}
        <TableEditable id='students-editable-id' columns={COLUMNS_EDITABLE} fetchData={data} newRow={NEW_STUDENT} />
        <hr />
        <button className='mx-3 my-2' type='button' onClick={handleSubmit}>submit</button>
      </main>
    </div>
  )
}